import { render, staticRenderFns } from "./ActionHandler.vue?vue&type=template&id=9cf9edec&scoped=true"
import script from "./ActionHandler.vue?vue&type=script&lang=ts"
export * from "./ActionHandler.vue?vue&type=script&lang=ts"
import style0 from "./ActionHandler.vue?vue&type=style&index=0&id=9cf9edec&prod&lang=scss"
import style1 from "./ActionHandler.vue?vue&type=style&index=1&id=9cf9edec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf9edec",
  null
  
)

export default component.exports